import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { createEgressCredential, deleteEgressCredential, getEgressCredentials, getEgressGateways, getEgressProviders, updateEgressCredential } from "../../actions/actionEgressProvider";
import DataTable from "../../components/Table/Table";
import { Modal, ModalFooter } from "../Form/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowProgress } from "@fortawesome/pro-light-svg-icons/faArrowProgress";
import { FormField, Groups, notifyFailure, notifySuccess } from "../Form/Form";
import { Field, formValueSelector, reduxForm, reset } from "redux-form";
import { renderField, renderPass, renderSelectField, renderTextArea, renderToggle, required, number } from "../../utils/formValidations";
import LoadingSpinner from "../LoadingSpinner";
import { ConfirmAction } from "../Table/NewTable";
import { faTrash } from "@fortawesome/pro-light-svg-icons/faTrash";
import SelectInput from "../SelectInput/SelectInput";

const selector = formValueSelector('EgressCredential')

function EgressCredential(props) {

  const { handleSubmit, egress_provider_id, allow_all_gateways, limit_active_connections } = props
  const { t } = useTranslation('common');
  const dispatch = useDispatch()

  const [modal, setModal] = useState(false)
  const [confirmModal, setConfirmModal] = useState(false)
  const [edit, setEdit] = useState(false)
  const [credentials, setCredentials] = useState(null)
  const [credential, setCredential] = useState(null)
  const [gateways, setGateways] = useState(null)
  const [selectedGateways, setSelectedGateways] = useState([])
  const [egressProviderOptions, setEgressProviderOptions] = useState([])
  const egressMappings = useSelector(state => state.egress_provider.egressMappings) || null
  const egress_providers = useSelector(state => state.egress_provider.egress_providers) || null
  const egressCredentialLoading = useSelector(state => state.egress_provider.egressCredentialLoading) || null
  const egressCredentials = useSelector(state => state.egress_provider.egressCredentials) || null
  const egressGateways = useSelector(state => state.egress_provider.egress_gateways) || null

  useEffect(() => {
    dispatch(getCredentials())
    dispatch(getEgressProviders())
    dispatch(getEgressGateways())
  }, []);

  useEffect(() => {
    const provider_options = egress_providers ? egress_providers.filter(function(egress_provider){
      return egress_provider.is_managed === false;
    }) : [];
    setEgressProviderOptions(provider_options)
  }, [egress_providers])

  useEffect(() => {
    if (egressMappings !== null) {
      dispatch(getCredentials())
    }
  }, [egressMappings]);

  useEffect(() => {
    if (currentProvider && egressGateways !== null) {
      let optionsGateways = [];
      egressGateways.map(opt => {
        if (opt.egress_provider_id === currentProvider.egress_provider_id) {
          optionsGateways.push({ label: opt.name, value: opt.egress_gateway_id });
        }
      });
      optionsGateways.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);
      setGateways(optionsGateways)
    }
  }, [egress_provider_id]);

  useEffect(() => {
    if (egressCredentials !== null) {
      setCredentials(egressCredentials.filter(cred => cred[props.type] === props.source_id.replaceAll('-', '')))
    }
  }, [egressCredentials]);

  useEffect(() => {
    if (modal === false) {
      props.change('egress_credential_id', null)
      props.change('name', '')
      props.change('egress_provider_id', null)
      props.change('allow_all_gateways', true)
      props.change('selected_gateways', null)
      props.change('limit_active_connections', false)
      props.change('active_connection_limit', 0)
      props.change('username', '')
      props.change('password', '')
      props.change('wireguard_private_key', '')
      props.change('custom_credential', '')
      props.change('tailscale_key', '')
      props.change('enabled', true)
      props.change(props.type, null)
      setSelectedGateways([])
    }
  }, [modal]);

  const getCredentials = () => {
      return getEgressCredentials({
          type: props.type,
          id: props.source_id.replaceAll('-', '')
      })
  }
  
  const currentProvider = egress_provider_id && egress_providers && egress_providers.find(provider => provider.egress_provider_id === egress_provider_id)

  const deleteMapping = async (setCredential = false) => {
    const egress_credential_id = setCredential || credential.egress_credential_id
    let data = { egress_credential_id }

    try {
      const { response: { error_message: errorMessage } } = await dispatch(deleteEgressCredential(data));
      notifySuccess({ errorMessage, type: 'delete' })
      if (!setCredential) {
        dispatch(getCredentials())
      }
    } catch (error) {
      notifyFailure({ error, type: 'delete' })
    }
    setConfirmModal(false)
  }

  const tableColumns = [
    {
      type: "text",
      name: t('egress_provider.name'),
      accessor: "name",
    },
    {
      type: "text",
      name: t('egress_provider.egress-provider-id'),
      accessor: "egress_provider.name",
    },
    {
      type: "flag",
      name: t('egress_provider.enabled'),
      accessor: "enabled",
    },
    {
      type: "flag",
      name: t('egress_provider.allow-all-gateways'),
      accessor: "allow_all_gateways",
    },
    {
      type: "number",
      name: t('egress_provider.active-connections'),
      accessor: "active_connections",
    },
    {
        type: "flag",
        name: t('egress_provider.limit-active-connections'),
        accessor: "limit_active_connections",
    },
    {
        type: "number",
        name: t('egress_provider.active-connection-limit'),
        accessor: "active_connection_limit",
        showByDefault: false,
    },
    {
      type: "text",
      name: t('egress_provider.username'),
      accessor: "username",
      showByDefault: false,
    },
    {
      type: "text",
      name: t('egress_provider.egress-credential-id-full'),
      accessor: "egress_credential_id",
      showByDefault: false,
    },
  ];

  const actions = [
    { id: "edit", icon: "fa-pencil", description: t('buttons.Edit') },
    { id: "delete", icon: "fa-trash", description: t('buttons.Delete') },
  ];

  const onAction = async (action, item) => {
    switch (action) {

      case "edit":
        updateCredential(item)
        setCredential(item)
        break;

      case "delete":
        setCredential(item)
        setConfirmModal(true)
        break;
      case "deleteMulti":
        const promises = []
        item.forEach(id => {
          const promise = deleteMapping(id)
          promises.push(promise)
        })
        await Promise.all(promises)
        dispatch(getCredentials())
        break;
    }
  }

  const updateCredential = (item) => {
    setSelectedGateways(item.egress_gateways.map(gateway => gateway.egress_gateway_id))
    setEdit(true)
    props.initialize({
      ...item
    })
    setModal(true)
  }

  const addCredential = async (userData) => {
    const type = userData.egress_credential_id ? 'update' : 'create'
    try {
      userData[props.type] = props.source_id.replaceAll('-', '')
      if (type == 'update') {
        const { response: { error_message: errorMessage } } = await dispatch(updateEgressCredential(userData))
        notifySuccess({ errorMessage, type: 'update' })
      } else {
        const { response: { error_message: errorMessage } } = await dispatch(createEgressCredential(userData))
        notifySuccess({ errorMessage, type: 'create' })
      }
      dispatch(getCredentials())
    } catch (error) {
      notifyFailure({ error, type })
    }
    setModal(false)
  }

  if (egressCredentialLoading) {
    return (<div> <LoadingSpinner /></div>);
  }
  return (
    <React.Fragment>
      <DataTable
        id="egress_mapping_credentials"
        data={credentials}
        columns={tableColumns}
        actions={actions}
        onAction={onAction}
        mainId="egress_credential_id"
        add={{
          name: t('buttons.Add'),
          onClick: () => { setModal(true); setEdit(false) }
        }}
      />
      <Modal
        icon={<FontAwesomeIcon icon={faArrowProgress} />}
        iconBg="tw-bg-blue-500 tw-text-white"
        title="egress_provider.configure-egress-credential"
        contentRaw={
          <Groups noPadding section="egress_provider" className='tw-text-left tw-mt-8' onSubmit={handleSubmit(addCredential)}>
            <p className="tw-pt-4 tw-text-xs" style={{ color: 'var(--text-color-muted-more)' }}>{t("egress_provider.configure-egress-credential-text")}</p>
            <FormField className="tw-flex tw-items-center tw-justify-between">
              <Field type="text"
                name="enabled"
                id="enabled"
                component={renderToggle}
              />
            </FormField>
            <Field type="select"
              name="egress_provider_id"
              id="egress_provider_id"
              disabled={edit}
              component={renderSelectField}
              validate={required} required
            >
              <option value="">Select...</option>
              {egressProviderOptions && egressProviderOptions.map(provider => <option value={provider.egress_provider_id}>{provider.name}</option>)}

            </Field>
            {egress_provider_id &&(
              <Field type="text"
                name="name"
                id="name"
                component={renderField}
                validate={required} required
              />
            )}
            {egress_provider_id && currentProvider.egress_provider_type === 'openvpn' && (
              <React.Fragment>
                <Field type="text"
                  name="username"
                  help="kb-26-5"
                  id="username"
                  component={renderField}
                  validate={required} required
                />
                <Field type="text"
                  name="password"
                  help="kb-26-6"
                  id="password"
                  component={renderPass}
                  validate={required} required
                />
              </React.Fragment>
            )}
            {egress_provider_id && currentProvider.egress_provider_type === 'tailscale' && (
            <Field type="text"
              name="tailscale_key"
              help="kb-26-7"
              id="tailscale_key"
              component={renderPass}
              validate={required} required
            />
            )}
            {egress_provider_id && currentProvider.egress_provider_type === 'wireguard' && (
            <Field type="text"
              name="wireguard_private_key"
              help="kb-26-8"
              id="wireguard_private_key"
              component={renderPass}
              validate={required} required
            />
            )}
            {egress_provider_id && currentProvider.egress_provider_type === 'custom' && (
            <Field type="text"
              name="custom_credential"
              help="kb-26-9"
              id="custom_credential"
              component={renderTextArea}
              validate={required} required
            />
            )}
            {egress_provider_id && (
              <React.Fragment>
                <FormField className="tw-flex tw-items-center tw-justify-between">
                  <Field type="text"
                    name="allow_all_gateways"
                    help="kb-26-10"
                    id="allow_all_gateways"
                    component={renderToggle}
                  />
                </FormField>

                {!allow_all_gateways && (
                  <Field
                    multi
                    onChange={(details) => setSelectedGateways(details)}
                    selectedValue={selectedGateways}
                    name="selected_gateways"
                    help="kb-26-11"
                    id="selected_gateways"
                    component={SelectInput}
                    options={gateways}>
                  </Field>
                )}
              </React.Fragment>
            )}
            {egress_provider_id && (
              <React.Fragment>
                <FormField className="tw-flex tw-items-center tw-justify-between">
                  <Field type="text"
                    name="limit_active_connections"
                    help="kb-26-12"
                    id="limit_active_connections"
                    component={renderToggle}
                  />
                </FormField>

                {limit_active_connections && (
                  <Field
                    type="number"
                    name="active_connection_limit"
                    help="kb-26-13"
                    id="active_connection_limit"
                    component={renderField}
                    validate={number} required
                  />
                )}
              </React.Fragment>
            )}

            <ModalFooter saving={false} cancel={() => setModal(false)} saveName='buttons.Save' />
          </Groups>
        }
        open={modal}
        setOpen={setModal}
      />
      <ConfirmAction
        confirmationDetails={{
          action: null,
          details: {
            title: t('egress_provider.notify-delete-title-mapping'),
            text: t('egress_provider.are-you-sure-you-want-to-delet-cred'),
            iconBg: 'tw-bg-pink-700 tw-text-white',
            icon: <FontAwesomeIcon icon={faTrash} />,
            confirmBg: 'tw-bg-pink-700',
            confirmText: t('buttons.Delete'),
          }
        }}
        open={confirmModal}
        externalClose={true}
        setOpen={setConfirmModal}
        onAction={deleteMapping}
      />
    </React.Fragment>
  )
}

EgressCredential = reduxForm({
  form: 'EgressCredential'
})(EgressCredential)

EgressCredential = connect(  // eslint-disable-line
  state => ({
    egress_provider_id: selector(state, 'egress_provider_id'),
    allow_all_gateways: selector(state, 'allow_all_gateways'),
    limit_active_connections: selector(state, 'limit_active_connections'),
    egress_credential_id: selector(state, 'egress_credential_id'),
  }))
  (EgressCredential);

export default EgressCredential
